import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Grid,
  TextField,
  Container,
} from '@material-ui/core'
import { useState } from 'react'
import { Button, useNotify } from 'react-admin'
import Api from '../../../Apis/api.service'

const buildResolutionTree = (votes) => {
  const votesTree = votes.reduce((acc, vote) => {
    if (votes.some((child) => vote.libelle === child.representant)) {
      return [
        ...acc,
        {
          ...vote,
          children: [],
        },
      ]
    } else if (
      vote.representant &&
      !votes.some((v) => v.libelle === vote.representant) &&
      !acc.some((v) => v.libelle === vote.representant)
    ) {
      return [
        ...acc,
        {
          libelle: vote.representant,
          isNotCoowner: true,
          children: [],
        },
      ]
    } else if (!vote.representant || vote.libelle === vote.representant) {
      return [...acc, vote]
    }
    return acc
  }, [])

  for (const child of votes) {
    votesTree
      .find(
        (parent) =>
          parent.libelle === child.representant &&
          parent.libelle !== child.libelle
      )
      ?.children.push(child)
  }
  return votesTree
}

export const SendMultiVotes = (props) => {
  const { record, resolution, isResolutionOpen, refresh } = props
  const [votesValues, setVotesValues] = useState({})
  const [search, setSearch] = useState('')

  const notify = useNotify()
  const sendVotes = async () => {
    const data = {
      ag_id: record.id,
      ...votesValues,
      multivotes: true,
      ag_registrations: record.ag_registrations,
      resolution_id: resolution.id,
    }

    const result = await Api.resolutions.create({ ...data })
    const response_data = result.data
    if (result.status === 200) {
      notify('Les votes sont faits.')
      refresh()
    } else {
      notify(response_data.message, 'warning')
    }
  }

  if (!isResolutionOpen && resolution?.null_votes.length > 0) {
    return (
      <Box padding={5}>
        <p>
          Vous devez d'abord ouvrir la résolution au vote pour saisir les votes.
        </p>
      </Box>
    )
  }

  if (!resolution?.null_votes || resolution?.null_votes.length === 0) {
    return (
      <Box padding={5}>
        <p>
          Tous les copropriétaires enregistrés ont voté. Aucune saisie
          nécessaire.
        </p>
      </Box>
    )
  }

  const options = [
    {
      label: 'Tous pour',
      value: 'Pour',
    },
    {
      label: 'Tous contre',
      value: 'Contre',
    },
    {
      label: 'Tous abstention',
      value: 'Abstention',
    },
  ]

  const votesTree = buildResolutionTree(resolution.null_votes)

  const loweredSearch = search.toLowerCase().trim()

  return resolution?.null_votes.length > 0 ? (
    <Box padding={5}>
      <Grid container spacing={1} style={{ marginBottom: '16px' }}>
        {options.map((option) => (
          <Grid key={option.value} item>
            <Button
              label={option.label}
              variant="contained"
              color="secondary"
              onClick={() => {
                setVotesValues(
                  resolution.null_votes.reduce(
                    (acc, v) => ({
                      ...acc,
                      [`param_agr_${v.agr_id}`]: option.value,
                    }),
                    {}
                  )
                )
              }}
            />
          </Grid>
        ))}
        <Container style={{ maxWidth: '250px', width: '250px' }}>
          <TextField
            label="Rechercher"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            size="small"
            fullWidth
            variant="outlined"
          />
        </Container>
      </Grid>
      {votesTree
        .filter(
          (parent) =>
            !loweredSearch ||
            parent.libelle?.toLowerCase().includes(loweredSearch) ||
            parent.children?.some((child) =>
              child.libelle?.toLowerCase().includes(loweredSearch)
            )
        )
        .map((parent) => {
          const label = parent.libelle
          return (
            <Box marginBottom={2} key={parent.libelle}>
              {!parent.isNotCoowner ? (
                <RowRadioButtonsGroup
                  libelle={label}
                  id={parent.agr_id}
                  setVotesValues={setVotesValues}
                  value={votesValues[`param_agr_${parent.agr_id}`]}
                  represented={parent.children}
                />
              ) : (
                <FormLabel>{label}</FormLabel>
              )}
              {parent.children
                ?.filter(
                  (child) =>
                    !loweredSearch ||
                    child.libelle?.toLowerCase().includes(loweredSearch)
                )
                .map((child) => {
                  const label = child.libelle

                  return (
                    <Box
                      paddingLeft={4}
                      borderLeft="1px solid grey"
                      key={child.agr_id}
                    >
                      <RowRadioButtonsGroup
                        libelle={label}
                        id={child.agr_id}
                        setVotesValues={setVotesValues}
                        value={votesValues[`param_agr_${child.agr_id}`]}
                      />
                    </Box>
                  )
                })}
            </Box>
          )
        })}
      {loweredSearch ? (
        <Button
          label="Retourner à la liste"
          variant={'outlined'}
          onClick={(e) => {
            e.preventDefault()
            setSearch('')
          }}
        />
      ) : (
        <Box
          sx={{
            p: 2,
            position: 'sticky',
            bottom: -8,
            bgcolor: 'white',
          }}
        >
          <Button
            label="Faire voter"
            disabled={!Object.keys(votesValues).length}
            sx={{
              background: '#143A5F',
              color: 'white',
              padding: '10px',
              '&:hover': {
                background: '#143A5F',
                opacity: 0.8,
              },
              '&:disabled': {
                background: '#ccc',
              },
            }}
            onClick={(e) => {
              e.preventDefault()
              sendVotes()
            }}
          />
        </Box>
      )}
    </Box>
  ) : (
    <p>
      Tous les coproprietaires enregistrés ont votés. Aucune saisie nécessaire.
    </p>
  )
}
function RowRadioButtonsGroup({
  libelle,
  id,
  setVotesValues,
  value,
  represented,
}) {
  return (
    <FormControl>
      <FormLabel id={`param_agr_${id}`}>{libelle}</FormLabel>
      <RadioGroup
        row
        aria-labelledby={`param_agr_${id}`}
        name={`param_agr_${id}`}
        onChange={(e) => {
          setVotesValues((prevVal) => {
            const newValue = e.target.value
            const updates = { ...prevVal, [`param_agr_${id}`]: newValue }

            if (represented && represented.length > 0) {
              represented.forEach((child) => {
                updates[`param_agr_${child.agr_id}`] = newValue
              })
            }

            return updates
          })
        }}
        value={value || null}
      >
        <FormControlLabel value="Pour" control={<Radio />} label="Pour" />
        <FormControlLabel value="Contre" control={<Radio />} label="Contre" />
        <FormControlLabel
          value="Abstention"
          control={<Radio />}
          label="Abstention"
        />
      </RadioGroup>
    </FormControl>
  )
}

export default SendMultiVotes
